import { render, staticRenderFns } from "./riverOpen.vue?vue&type=template&id=ccffcb24&scoped=true&"
import script from "./riverOpen.vue?vue&type=script&lang=js&"
export * from "./riverOpen.vue?vue&type=script&lang=js&"
import style0 from "./riverOpen.vue?vue&type=style&index=0&id=ccffcb24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccffcb24",
  null
  
)

export default component.exports